import api from './api';

export interface Favorite {
  id: string;
  createdAt: string;
  product: {
    id: string;
    title: string;
    price: string;
    thumbnail?: string | null;
    thumbnailUrl?: string | null;
  };
  user: {
    id: string;
    name: string;
    email: string;
  };
}

export const favoriteService = {
  /**
   * Add product to favorites
   */
  async addToFavorites(productId: string): Promise<Favorite> {
    const response = await api.post(`/favorites/${productId}`);
    return response.data;
  },

  /**
   * Remove product from favorites
   */
  async removeFromFavorites(productId: string): Promise<void> {
    await api.delete(`/favorites/${productId}`);
  },

  /**
   * Get user's favorites
   */
  async getMyFavorites(): Promise<Favorite[]> {
    const response = await api.get('/favorites');
    return response.data;
  },

  /**
   * Check if product is favorited
   */
  async checkIfFavorited(productId: string): Promise<boolean> {
    const response = await api.get(`/favorites/check/${productId}`);
    return response.data.isFavorited;
  },
};

